// extracted by mini-css-extract-plugin
module.exports = {"social-icons":"styles-m__social-icons__2ElHx","social-link":"styles-m__social-link__2bJ7z","social-link-item":"styles-m__social-link-item__3TaiB"};